import { Container, Flex, IconButton, Image } from "@chakra-ui/react";
import { HiMenuAlt1 } from "react-icons/hi";

import { useAppConfig } from "../../../context";
import React from "react";
import esg360Logo from "../../../assets/img/esg-teal-logo.png";

/**
 * Top navbar
 */
function PublicNavbar() {
  const { toggleSidebar } = useAppConfig();

  return (
    <Container id="navbar" minW="100vw" paddingBlock="4" px={8}>
      <Flex gap="2" justifyContent="space-between" alignItems="center">
        <IconButton /* Hm... This hamburger-for-mobile wasn't in the NavbarV2 code -- but surely we want it for mobile UI? */
          display={{ base: "inline-flex", md: "none" }}
          fontSize="lg"
          variant="outline"
          color="current"
          onClick={() => toggleSidebar()}
          icon={<HiMenuAlt1 />}
        />
        <Image
          width="32"
          src={esg360Logo}
          alt="esg360-logo"
        />
      </Flex>
    </Container>
  );
}


export default PublicNavbar;
